import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
// import { HttpLoaderFactory } from '../../../app.module';
import { FormsModule } from '@angular/forms';
import { RAFormModule } from '../../../ra-form/ra-form.module';
//  import { InvestoridRoutingModule } from './Investorid-routing.module';
import { InvestoridComponent } from './Investorid.component';
import { HttpLoaderFactory } from 'src/app/http-loader-factory';
@NgModule({
imports: [
CommonModule,
//  InvestoridRoutingModule,
RAFormModule,
FormsModule,
HttpClientModule,
TranslateModule.forChild({
loader: {
provide: TranslateLoader,
useFactory: HttpLoaderFactory,// Moved to Seperate File By Mirsha
deps: [HttpClient]
}
}),
],
declarations: [
InvestoridComponent,
],
exports:[
InvestoridComponent,
],
})
export class InvestoridModule { }
